<script>
  import MyTable from '../../components/MyTable.vue';
  import { reactive, onMounted, ref, inject, watch } from 'vue'
  import moment from "moment";
  export default {
    components: {
      MyTable
    },
    setup () {

      const state = reactive({
        treinadores: [
          { id: 1, name: 'Márcio Novais', payment_date: '2024-08-10', access_date: '2024-11-10', students_quantity: 14 },
          { id: 1, name: 'Pedro Nolasco', payment_date: '2024-10-15', access_date: '2024-12-14', students_quantity: 27 },
          { id: 1, name: 'Alvaro Costa', payment_date: '2024-11-22', access_date: '2025-01-31', students_quantity: 4 },
          { id: 1, name: 'Gustavo Assis', payment_date: '2024-10-01', access_date: '2024-12-31', students_quantity: 9 },
        ],
        months: [
          { mes: "Janeiro", numero: '01' },
          { mes: "Fevereiro", numero: '02' },
          { mes: "Março", numero: "03" },
          { mes: "Abril", numero: '04' },
          { mes: "Maio", numero: '05' },
          { mes: "Junho", numero: '06' },
          { mes: "Julho", numero: '07' },
          { mes: "Agosto", numero: '08' },
          { mes: "Setembro", numero: '09' },
          { mes: "Outubro", numero: '10' },
          { mes: "Novembro", numero: '11' },
          { mes: "Dezembro", numero: '12' }
        ],
        mesSelecionado: moment().format('MM'),
        anoSelecionado: moment().format('YYYY'),
      })

      const columns = ref([
        {
          label: 'Treinador',
          field: 'message_type'
        },
        {
          label: 'Data de pagamento',
          field: 'message_title'
        },
        {
          label: 'Data de expiração',
          field: 'message_title'
        },
        {
          label: 'Qtde de alunos',
          field: 'message_title'
        },
        {
          label: 'Ações',
          field: 'actions'
        }
      ])

      return {
        state,
        columns
      }
    }
  }

</script>

<template>
  <div>
    <div class="d-flex justify-content-between">
      <h3 class="mb-3">
        Controle financeiro
      </h3>
      <div>
        <table class="table-bordered float-end text-sm">

          <tbody>
          <tr class="">
            <td class="text-center px-3">Valor recebido acumulado</td>
            <td class="text-center px-3">R$ 47.254,36</td>
          </tr>
          <tr class="">
            <td class="text-center px-3">Valor recebido no mês</td>
            <td class="text-center px-3">R$ 254,88</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mb-3 mt-5">
      <div class="col-12 d-flex justify-content-center align-items-end">
        <div class="mx-2">
          <label class="form-label mt-2">Mês referência</label>
          <select class="form-control form-control-sm custom-select" v-model="state.mesSelecionado">
            <option v-for="(item, index) in state.months" :key="index" :value="item.numero" selected>{{ item.mes }}</option>
          </select>
        </div>
        <div class="mx-2">
          <label class="form-label mt-2">Ano referência</label>
          <select class="form-control form-control-sm custom-select" v-model="state.anoSelecionado">
            <option value="2023" selected>2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
          </select>
        </div>
        <div class="mx-2">
          <button type="button" class="mb-0 btn btn-success btn-sm" @click="buscarDados">
            Filtrar
          </button>
        </div>
      </div>
    </div>
    <MyTable
        :data="state.treinadores"
        :columns="columns"
        :searchable="false"
        :itemsPerPage="12">
      <template v-slot:row="{ row }">
        <td class="text-sm pointer">
          {{ row.name }}
        </td>
        <td class="text-sm text-center pointer">
          {{ $filters.datePtbr(row.payment_date) }}
        </td>
        <td class="text-sm text-center pointer">
          {{ $filters.datePtbr(row.access_date) }} <br>
          <span class="small">
            {{ $filters.diffDays(row.access_date) }} dias restante
          </span>
        </td>
        <td class="text-sm text-center pointer">
          {{ row.students_quantity }}
        </td>
        <td class="text-sm align-content-center">
          <div class="float-end">
            <div>
              <router-link
                  class="w-100 pointer btn btn-outline-info btn-sm d-flex"
                  title="Detalhes"
                  :to="{ name: 'FinanceiroDetalhe', params: { id: row.id } }"
              >
                <i class="material-icons  me-1" >info</i>
                Detalhes

              </router-link>
            </div>
          </div>
        </td>
      </template>
    </MyTable>
  </div>
</template>

<style scoped>

</style>